<template>
  <div class="home" v-if="EnterData">
    <a accesskey="u" id="accesskey_u" href="#" title="上方區塊">
      :::
    </a>
    <div class="bg"></div>
    <div class="main">
      <div class="sitemap_box">
        <div class="container">
          <router-link :to="{ name: 'SiteMap', params: {} }" v-slot="{ navigate }">
            <button @click="navigate" class="sitemap_btn">{{ $t('網頁導覽') }}</button>
          </router-link>
        </div>
      </div>
      <div class="subtitle_box">
        <div class="container">
          <div class="subtitle">
            <h1>
              <!-- <img :src="EnterData.SiteLogo" alt="GMA logo" v-if="EnterData.SiteLogo"> -->
              <img src="img/GMAlogo.svg" alt="GMA logo" v-if="EnterData.SiteLogo">
              <img src="img/GMAlogo.svg" alt="GMA logo" v-else>
            </h1>
            <div class="box">
              <h2>因為音樂 我們再度相遇</h2>
              <h2> Music Brings Us Together</h2>
            </div>
          </div>
          <a accesskey="c" id="accesskey_c" href="#" title="中間主要內容區">
            :::
          </a>
          <div class="btn_box">
            <button @click="gotoUrl(EnterData.Button_Top_Url, false)" class="enter_btn">
              <p>{{ EnterData.Button_Top_Text_EN }}</p>
              <p>{{ EnterData.Button_Top_Text_CN }}</p>
            </button>
            <button @click="gotoUrl(EnterData.Button_Bottom_Url, false)" class="enter_btn">
              <p>{{ EnterData.Button_Bottom_Text_EN }}</p>
              <p>{{ EnterData.Button_Bottom_Text_CN }}</p>
            </button>
          </div>
        </div>
      </div>
      <div class="scroll_box">
        <div class="container">
          <button @click="scrollToText" class="scroll_btn">
            <p>Scroll</p>
            <img src="img/Scroll_arrow.svg" alt="">
          </button>
        </div>
      </div>
    </div>
    <div class="tcms-content">
      <div id="toolbarTop"></div>
      <div class="home">
        <div ref="text_box" class="text_box">
          <div class="container" v-if="EnterData && EnterData.Enter_Text" v-html="EnterData.Enter_Text">
          </div>
        </div>
      </div>
    </div>
    <div :class="['top_box', { 'add': isTop }]">
      <button @click="scrollToTop()" class="top_btn">
        <p>TOP</p>
      </button>
      <img class="top_bg" src="img/bg_top.svg" alt="">
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "金曲獎": "金曲獎",
    "金曲國際音樂節": "金曲國際音樂節",
    "網頁導覽": "網頁導覽",
  },
  en: {
    "首頁": "Home",
    "金曲獎": "Golden Melody Awards",
    "金曲國際音樂節": "Golden Melody Festival",
    "網頁導覽": "StieMap",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "Enter",
  i18n,
  components: {
    Slick,
  },
  data() {
    return {
      EnterData: null,
      isTop: false,
      local: "zh_tw",
    };
  },
  created: function () {
    // Vue.axios
    //   .get(
    //     this.$store.state.src + this.$store.state.subDirectory + "/Html/Home",
    //     {
    //       params: {
    //         lang: $cookies.get("gma_main_lang")
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     this.EnterData = response.data;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    this.EnterData = {
      "SiteUrl": "https://tavis.tw/gma/36th",
      "SiteLogo": "https://tavis.tw/gma/36th/Upload/Editor/95635b33-f644-44a6-9371-dc4a6ecaa672.webp",
      "Button_Top_Text_EN": "2025 Golden Melody Awards",
      "Button_Top_Text_CN": "金曲獎頒獎典禮 6/28 Sat.",
      "Button_Top_Url": "/gma/36th/#/Awards",
      "Button_Bottom_Text_EN": "2025 Golden Melody Festival",
      "Button_Bottom_Text_CN": "金曲國際音樂節 6/25 Wed.-6/27 Fri.",
      "Button_Bottom_Url": "/gma/36th/#/Festival",
      "Enter_Text": "<style type=\"text/css\">.tight-line {\n    line-height: 1.875rem;\n  }\n</style>\n<h2 class=\"title tight-line\">GMA (Golden Melody Awards &amp; Festival)</h2>\n\n<h2 class=\"tight-line\">含括金曲獎頒獎典禮及金曲國際音樂節等兩大活動。</h2>\n<style type=\"text/css\">.line-30 {\n    line-height: 1.875rem;\n  }\n</style>\n<hr class=\"text_line\" />\n<p class=\"line-30\">「金曲獎頒獎典禮」自1990年開始舉辦，為全球華語流行音樂工作者最極力爭取的重要獎項，2025年將邁入第36屆。精彩的頒獎典禮也是年度最受矚目的盛事，每年透過電視與網路串流播送至全球，全球觀看人數突破千萬。</p>\n\n<p class=\"line-30\">&nbsp;</p>\n\n<p class=\"line-30\">「金曲國際音樂節」源於2010年「金曲音樂週」，文化部影視及流行音樂產業局自2014年起將活動轉型為B2B產業媒合商展平台，與金曲獎頒獎典禮合併辦理，期將金曲獎打造成為國際性活動與獎項。2025金曲國際音樂節系列活動包括「音樂論壇」、「SHOWCASE售票演唱會」、「商展交易中心」、「商務媒合會」、「商務交流會」、「金曲36入圍新人演出」；廣邀亞、歐、美洲各國具代表性唱片公司、演出公司、經紀公司、影視業者、國際買家及音樂人等參與，希望促成國內外音樂相關產業交流與洽商，成為亞洲重要的商務媒合平台。</p>\n\n<p class=\"line-30\">&nbsp;</p>\n\n<p>&nbsp;</p>\n<style type=\"text/css\">.line-30 {\n    line-height: 1.875rem;\n  }\n</style>\n<h2 class=\"title line-30\">GMA (Golden Melody Awards &amp; Festival)</h2>\n\n<h2 class=\"line-30\">The GMA is a multi-event musical celebration featuring mainly the Golden Melody Awards and the</h2>\n<style type=\"text/css\">.line-20 {\n    line-height: 1.25rem;\n  }\n</style>\n<hr class=\"text_line\" />\n<p class=\"line-30\">The Golden Melody Awards Ceremony has been held since 1990 and is one of the most prestigious awards that Mandarin pop music professionals strive for. In 2025, it will enter its 36th edition. The spectacular award ceremony is also one of the most anticipated annual events, broadcast worldwide each year through television and online streaming, attracting a global audience of over tens of millions.</p>\n\n<p class=\"line-30\">&nbsp;</p>\n\n<p class=\"line-30\">The Golden Melody Festival originated from the Golden Melody Week of 2010. In 2014, the Bureau of Audiovisual and Music Industry Development, Ministry of Culture transformed the Golden Melody Week into a platform for B2B exchanges. The Golden Melody Festival is hosted in tandem with the GMA in the hopes of building the GMA into an event and award of global significance. A series of 2025&nbsp;Golden Melody Festival include Conference, SHOWCASE concerts, Biz-matching Center, Speed Meeting, Pitching and 36th GMA Best New Artist Nominees Performances. Invitees come from Asia, Europe and the Americas and consist of key figures in the record, performance, artist agency, television industries, as well as international buyers and musicians. The aim is to facilitate business exchange between Taiwan and the world and make the event an important business platform in Asia.</p>\n"
    };
  },
  mounted: function () {
    if ($cookies.isKey("gma_the_site_lang")) {
      i18n.locale = $cookies.get("gma_the_site_lang");
      this.local = $cookies.get("gma_the_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
    let that = this;
    // 監聽頁面滾動
    window.addEventListener('scroll', function () {
      // 判斷滾動高度，若大於100px則顯示top-bar按鈕
      if (window.scrollY > 500) {
        that.isTop = true;
      } else {
        that.isTop = false;
      }
    });
  },
  updated: function () {
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    scrollToText() {
      $('html, body').animate({
        scrollTop: $('.text_box').offset().top
      }, 0);
    },
    gotoUrl: function (Url, Blank) {
      if (Blank) {
        window.open(Url, "_blank");
      } else {
        location.href = Url;
      }
    },
  },
};
</script>